import styled from 'styled-components/macro';

import ShapeIcon from 'components/ShapeSelector/ShapeIcon';

const Paper = styled(ShapeIcon)`
  left: 0;
  top: 0;
`;

export default Paper;
